import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { ShadowDom } from "../../component/ShadowDom";
import {
  getParticipantsPrivacy,
  getParticipantsPrivacyLanguages,
  getUserPrivacy,
  getUserPrivacyLanguages,
} from "../../actions";
import { useParams } from "react-router-dom";

export const Privacy = () => {
  const dispatch = useDispatch();
  const { version, lang, user_type } = useParams();
  const privacy = useSelector((state) => state.uiReducer.privacy);

  useEffect(() => {
    if (user_type === "participants") {
      dispatch(getParticipantsPrivacyLanguages({ version }));
    }
    if (user_type === "clinical_team") {
      dispatch(getUserPrivacyLanguages({ version }));
    }
  }, [version, user_type, dispatch]);

  useEffect(() => {
    if (user_type === "participants") {
      dispatch(getParticipantsPrivacy({ version, language: lang }));
    }
    if (user_type === "clinical_team") {
      dispatch(getUserPrivacy({ version, language: lang }));
    }
  }, [version, lang, user_type, dispatch]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ShadowDom html={privacy} />
    </Box>
  );
};
